import React, { useEffect, useState, useCallback, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { HiOutlinePencilAlt } from "react-icons/hi";
import { IoSearch, IoEyeOutline, IoTrashOutline, IoChevronUp, IoChevronDown, IoDuplicateOutline } from "react-icons/io5";
import { IoMdArchive } from "react-icons/io";
import { MdOutlineWifiTetheringErrorRounded } from "react-icons/md";
import Search from "../../Jobick/Jobs/ui/search";
import { toast } from "react-toastify";
import { getItemsPerPage } from "../../../utils/CommonFunctions";
import JobService from "../../../../services/JobService";
import { colors } from "../../../config/colors";
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/solid';
import CategoryService from "../../../../services/CategoryService";
import UserService from "../../../../services/UserService";
import CustomerService from "../../../../services/CustomerService";
import TaskService from "../../../../services/TaskService";
import { DateRangePicker } from 'react-date-range';
import { format, isValid, startOfMonth, endOfMonth, startOfWeek, endOfWeek, startOfDay, endOfDay } from 'date-fns';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import DeleteModal from "../../shared/DeleteModal";
import JobCalendar from "../JobCalendar";
import { getJobTitleLabel, getJobTitleLabelPlural, getChargeOutRateTitle } from "../../../utils/jobTitleLabel";

const ListJob = () => {
  const jobLabel = getJobTitleLabel();
  const jobPluralLabel = getJobTitleLabelPlural();
  const chargeOutRateTitle = getChargeOutRateTitle();
  const navigate = useNavigate();
  const location = useLocation();

  const drafts = location.pathname.includes('draft-list');

  const [pageVal, setPageVal] = useState(1);
  const [totalJobs, setTotalJobs] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [jobList, setJobList] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [jobToDelete, setJobToDelete] = useState(null);
  const jobsPerPage = getItemsPerPage();
  const [selectedStatus, setSelectedStatus] = useState('ALL');
  const [isLoading, setIsLoading] = useState(false);
  const [showArchivedJobs, setShowArchivedJobs] = useState(false);
  const [viewMode, setViewMode] = useState(() => localStorage.getItem('jobsViewMode') || 'list');
  const [calendarDate, setCalendarDate] = useState(null);
  const [calendarView, setCalendarView] = useState('month');
  const [calendarRange, setCalendarRange] = useState(null);

  const getCalendarRange = (view, date) => {
    if (!date) return null;
    const d = new Date(date);
    if (view === 'month') return { start: startOfMonth(d), end: endOfMonth(d) };
    if (view === 'week') return { start: startOfWeek(d), end: endOfWeek(d) };
    return { start: startOfDay(d), end: endOfDay(d) };
  };

  const [totalCompletedJobs, setTotalCompletedJobs] = useState(0);
  const [totalRevenue, setTotalRevenue] = useState(0);

  const [categories, setCategories] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [tasks, setTasks] = useState([]);

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [selectedTasks, setSelectedTasks] = useState([]);

  const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
  const [showEmployeeDropdown, setShowEmployeeDropdown] = useState(false);
  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
  const [showTaskDropdown, setShowTaskDropdown] = useState(false);

  const [categorySearchTerm, setCategorySearchTerm] = useState("");
  const [employeeSearchTerm, setEmployeeSearchTerm] = useState("");
  const [customerSearchTerm, setCustomerSearchTerm] = useState("");
  const [taskSearchTerm, setTaskSearchTerm] = useState("");

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection'
    }
  ]);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const datePickerRef = useRef(null);

  // Add refs for dropdowns
  const categoryDropdownRef = useRef(null);
  const employeeDropdownRef = useRef(null);
  const customerDropdownRef = useRef(null);
  const taskDropdownRef = useRef(null);

  // Modify initial state to 'all'
  const [approvalStatus, setApprovalStatus] = useState('all');

  // Modify statusOptions to remove UN_APPROVED
  const statusOptions = [
    { label: `All ${jobPluralLabel}`, value: 'ALL' },
    { label: 'Upcoming', value: 'UPCOMING' },
    { label: 'Past Due', value: 'PAST_DUE' },
    { label: 'In Progress', value: 'IN_PROGRESS' },
    { label: 'Completed', value: 'COMPLETED' },
    { label: 'Cancelled', value: 'CANCELLED' },
    { label: 'Skipped', value: 'SKIPPED' },
    { label: 'Incomplete', value: 'FAILED' },
  ];

  // Add approvalStatusOptions
  const approvalStatusOptions = [
    { label: 'All', value: 'all' },
    { label: 'Approved', value: 'approved' },
    { label: 'Not Approved', value: 'not-approved' },
  ];

  const SEARCH_DEBOUNCE_DELAY = 500;

  const debouncedSearch = useCallback(
    debounce((value) => {
      setSearchVal(value);
    }, SEARCH_DEBOUNCE_DELAY),
    []
  );

  useEffect(() => {
    setInputValue("");
  }, [location.pathname]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    debouncedSearch(value);
  };



  const handlePreviousPageClick = () => {
    if (pageVal === 1) return;
    setPageVal(pageVal - 1);
  };

  const handleNextPageClick = () => {
    if (pageVal >= totalPages) return;
    setPageVal(pageVal + 1);
  };

  const handleDeleteClick = (jobId) => {
    setJobToDelete(jobId);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    try {
      const response = await JobService.deleteJob(jobToDelete);
      if (response.success) {
        toast.success(`${jobLabel} deleted successfully`);
        fetchJobList(); // Refresh the list
      } else {
        throw new Error(`Failed to delete ${jobLabel.toLowerCase()}`);
      }
    } catch (error) {
      console.error(`Error deleting ${jobLabel.toLowerCase()}:`, error);
      toast.error(`Failed to delete ${jobLabel.toLowerCase()}`);
    } finally {
      setShowDeleteModal(false);
      setJobToDelete(null);
    }
  };

  const fetchJobList = async (noDateFilter = false, forCalendar = false, range = null) => {
    setIsLoading(true);
    !jobList && setLoading(true);
    try {
      const page = forCalendar ? 1 : pageVal;
      const limit = forCalendar ? 500 : jobsPerPage;
      const startDate = forCalendar && range ? format(range.start, 'yyyy-MM-dd') : (noDateFilter ? null : dateRange[0].startDate ? format(dateRange[0].startDate, 'yyyy-MM-dd') : null);
      const endDate = forCalendar && range ? format(range.end, 'yyyy-MM-dd') : (noDateFilter ? null : dateRange[0].endDate ? format(dateRange[0].endDate, 'yyyy-MM-dd') : null);

      const response = await JobService.getJobs(
        page,
        limit,
        searchVal,
        selectedStatus === 'ALL' ? null : selectedStatus,
        selectedCategories.join(','),
        selectedEmployees.join(','),
        selectedCustomers.join(','),
        selectedTasks.join(','),
        startDate,
        endDate,
        approvalStatus,
        drafts,
        showArchivedJobs
      );

      if (response.success) {
        const { data } = response;
        const total = data.pagination.total;
        setJobList(data.jobs);
        setTotalJobs(total);
        if (!forCalendar) {
          setTotalPages(Math.ceil(total / jobsPerPage));
        }
        setTotalCompletedJobs(data.completedJobsCount);
        setTotalRevenue(data.totalRevenue);
      } else {
        throw new Error("Failed to fetch jobs");
      }
    } catch (error) {
      console.error("Error fetching job list:", error);
      toast.error("Failed to fetch jobs");
    } finally {
      setIsLoading(false);
      setLoading(false);
    }
  };

  const handleStatusChange = (status) => {
    setSelectedStatus(status);
  };

  useEffect(() => {
    if (viewMode === 'list') fetchJobList();
  }, [drafts, pageVal, selectedStatus, selectedCategories, selectedEmployees, selectedCustomers, selectedTasks, showArchivedJobs, viewMode]);

  useEffect(() => {
    if (viewMode === 'calendar' && !calendarDate) {
      const now = new Date();
      setCalendarDate(now);
      setCalendarView('month');
      setCalendarRange(getCalendarRange('month', now));
    }
  }, [viewMode]);
  useEffect(() => {
    if (viewMode === 'calendar' && calendarRange) fetchJobList(false, true, calendarRange);
  }, [viewMode, calendarRange, selectedStatus, selectedCategories, selectedEmployees, selectedCustomers, selectedTasks, searchVal, approvalStatus, showArchivedJobs, drafts]);

  useEffect(() => {
    if (viewMode !== 'list') return;
    if (pageVal === 1) fetchJobList();
    else setPageVal(1);
  }, [searchVal, showArchivedJobs, viewMode]);

  useEffect(() => {
    return () => debouncedSearch.cancel();
  }, [debouncedSearch]);

  function debounce(func, wait) {
    let timeout;
    const debouncedFunc = function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
    debouncedFunc.cancel = function () {
      clearTimeout(timeout);
    };
    return debouncedFunc;
  }

  const handleEditClick = (jobId) => {
    navigate(`/edit-job/${jobId}`);
  };

  const handleCreateJob = () => {
    navigate("/create-job");
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString();
  };

  const formatTime = (timeString) => {
    return timeString;
  };

  const pgItem1 =
    pageVal === 1
      ? 1
      : pageVal >= totalPages && totalPages > 2
        ? totalPages - 2
        : pageVal - 1;
  const pgItem2 =
    pageVal === 1
      ? 2
      : pageVal >= totalPages && totalPages > 2
        ? totalPages - 1
        : pageVal;
  const pgItem3 =
    pageVal === 1
      ? 3
      : pageVal >= totalPages && totalPages > 2
        ? totalPages
        : pageVal + 1;

  // Add functions to fetch filter options
  const fetchFilterOptions = async () => {
    try {
      const [categoriesRes, employeesRes, customersRes, tasksRes] = await Promise.all([
        CategoryService.getAllCategories(false), // Only get active categories
        UserService.getUsers({ role: 'EMPLOYEE' }),
        CustomerService.getCustomers(1, 1000), // Using a large limit
        TaskService.getTasks(1, 1000) // Using a large limit
      ]);

      console.log(">>>> ", categoriesRes);
      console.log(">>>> ", employeesRes);
      console.log(">>>> ", customersRes);
      console.log(">>>> ", tasksRes);

      if (categoriesRes.success) setCategories(categoriesRes.data);
      if (employeesRes.data.status === "success") setEmployees(employeesRes.data.data.users);
      if (customersRes.data) setCustomers(customersRes.data.data);
      if (tasksRes.success) setTasks(tasksRes.data);
    } catch (error) {
      console.error("Error fetching filter options:", error);
      toast.error("Failed to load filter options");
    }
  };

  // Add useEffect to fetch filter options
  useEffect(() => {
    fetchFilterOptions();
  }, []);

  // Add new state for approval status dropdown
  const [showApprovalDropdown, setShowApprovalDropdown] = useState(false);

  // Add ref for approval dropdown
  const approvalDropdownRef = useRef(null);

  // Add to useEffect for click outside handlers
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!approvalDropdownRef.current?.contains(event.target)) {
        setShowApprovalDropdown(false);
      }
      if (!categoryDropdownRef.current?.contains(event.target)) {
        setShowCategoryDropdown(false);
      }
      if (!employeeDropdownRef.current?.contains(event.target)) {
        setShowEmployeeDropdown(false);
      }
      if (!customerDropdownRef.current?.contains(event.target)) {
        setShowCustomerDropdown(false);
      }
      if (!taskDropdownRef.current?.contains(event.target)) {
        setShowTaskDropdown(false);
      }
      if (!datePickerRef.current?.contains(event.target)) {
        setShowDatePicker(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Add selection handlers
  const handleCategorySelect = (categoryId) => {
    setSelectedCategories(prev => {
      const isSelected = prev.includes(categoryId);
      return isSelected ? prev.filter(id => id !== categoryId) : [...prev, categoryId];
    });
  };

  const handleEmployeeSelect = (employeeId) => {
    setSelectedEmployees(prev => {
      const isSelected = prev.includes(employeeId);
      return isSelected ? prev.filter(id => id !== employeeId) : [...prev, employeeId];
    });
  };

  const handleCustomerSelect = (customerId) => {
    setSelectedCustomers(prev => {
      const isSelected = prev.includes(customerId);
      return isSelected ? prev.filter(id => id !== customerId) : [...prev, customerId];
    });
  };

  const handleTaskSelect = (taskId) => {
    setSelectedTasks(prev => {
      const isSelected = prev.includes(taskId);
      return isSelected ? prev.filter(id => id !== taskId) : [...prev, taskId];
    });
  };

  const filteredCategories = categories?.filter(cat => cat.categoryType.toLowerCase().includes(categorySearchTerm.toLowerCase()));
  const filteredEmployees = employees?.filter(emp => emp.name.toLowerCase().includes(employeeSearchTerm.toLowerCase()));
  const filteredCustomers = customers?.filter(cust => cust.name.toLowerCase().includes(customerSearchTerm.toLowerCase()));
  const filteredTasks = tasks?.filter(task => task.title.toLowerCase().includes(taskSearchTerm.toLowerCase()));

  const dateRangeButton = (
    <div className="relative" ref={datePickerRef}>
      <button
        onClick={() => setShowDatePicker(!showDatePicker)}
        className="inline-flex items-center px-4 py-2.5 border border-gray-200 rounded-lg hover:bg-gray-50 transition-all duration-200"
      >
        <span className="text-sm font-medium text-gray-700">
          {dateRange[0].startDate && dateRange[0].endDate
            ? `${format(dateRange[0].startDate, 'MMM dd, yyyy')} - ${format(dateRange[0].endDate, 'MMM dd, yyyy')}`
            : 'Date Range'}
        </span>
        {showDatePicker ? <IoChevronUp className="ml-2 w-4 h-4" /> : <IoChevronDown className="ml-2 w-4 h-4" />}
      </button>

      {showDatePicker && (
        <div className="absolute right-0 mt-2 z-[100] bg-white rounded-lg shadow-lg border border-gray-200">
          <div className="p-2">
            <DateRangePicker
              onChange={item => setDateRange([item.selection])}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={2}
              ranges={dateRange}
              direction="horizontal"
              rangeColors={[colors.primary.headingsBody]}
            />
            <div className="border-t mt-2 pt-2 flex justify-between px-2">
              <button
                onClick={() => {
                  setDateRange([{
                    startDate: null,
                    endDate: null,
                    key: 'selection'
                  }]);
                  setShowDatePicker(false);
                  fetchJobList(true);
                }}
                className="text-sm text-red-500 hover:text-red-700"
              >
                Clear
              </button>
              <button
                onClick={() => {
                  setShowDatePicker(false);
                  fetchJobList();
                }}
                className="text-sm text-primary-headings hover:text-primary-light"
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );

  // Add useEffect for approvalStatus changes (list view only – calendar has its own fetch)
  useEffect(() => {
    if (viewMode !== 'list') return;
    if (pageVal === 1) fetchJobList();
    else setPageVal(1);
  }, [approvalStatus, showArchivedJobs, viewMode]);

  const [archivingJob, setArchivingJob] = useState(null);

  const handleArchiveJob = async (jobId, isArchived = true) => {
    try {
      setArchivingJob(jobId);
      const response = await JobService.archiveJob(jobId, isArchived);
      if (response.success) {
        toast.success(isArchived ? `${jobLabel} archived successfully` : `${jobLabel} unarchived successfully`);
        fetchJobList();
      } else {
        throw new Error(`Failed to ${isArchived ? 'archive' : 'unarchive'} ${jobLabel.toLowerCase()}`);
      }
    } catch (error) {
      console.error(`Error ${isArchived ? 'archiving' : 'unarchiving'} ${jobLabel.toLowerCase()}:`, error);

      // Handle API error response with detailed message
      if (error.response?.data?.error) {
        toast.error(error.response.data.error);
      } else if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error(`Failed to ${isArchived ? 'archive' : 'unarchive'} ${jobLabel.toLowerCase()}`);
      }
    } finally {
      setArchivingJob(null);
    }
  };

  return (
    <>
      {/* {isLoading && (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 z-50 flex items-center justify-center backdrop-blur-sm">
          <div className="bg-white p-6 rounded-xl shadow-xl flex items-center gap-4">
            <div 
              className="w-8 h-8 border-4 border-gray-300 rounded-full animate-spin"
              style={{ borderTopColor: colors.primary.headingsBody }}
            />
            <p className="text-gray-700 font-medium">Loading...</p>
          </div>
        </div>
      )} */}

      <div className="h-[calc(100vh-4rem)] overflow-y-auto bg-gradient-to-b from-white to-accent-light/10 p-6">
        {/* Header Section with Stats */}
        <div className="mb-8 min-w-0">
          <div className="flex flex-col gap-4 sm:flex-row sm:justify-between sm:items-start mb-2">
            <div className="min-w-0">
              <h2 className="text-2xl font-bold text-primary-headings mb-2">
                {showArchivedJobs ? `Archived ${jobPluralLabel}` : `${jobLabel} Management`}
              </h2>
              <p className="text-sm text-primary-light mb-6 sm:mb-0">
                {showArchivedJobs
                  ? `View and manage archived ${jobPluralLabel.toLowerCase()}`
                  : `Track and manage your ${jobPluralLabel.toLowerCase()} efficiently`}
              </p>
            </div>
            {!drafts && (
              <div className="flex flex-wrap items-center gap-2 shrink-0">
                <button
                  onClick={() => {
                    const mode = viewMode === 'list' ? 'calendar' : 'list';
                    setViewMode(mode);
                    localStorage.setItem('jobsViewMode', mode);
                    if (mode === 'calendar') {
                      const now = new Date();
                      setCalendarDate(now);
                      setCalendarView('month');
                      setCalendarRange(getCalendarRange('month', now));
                    }
                  }}
                  className={`inline-flex items-center px-3 py-2 sm:px-4 rounded-md border transition-colors duration-200 shadow-sm whitespace-nowrap text-sm ${viewMode === 'calendar' ? 'bg-primary-headings text-white border-primary-headings' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                    }`}
                  style={viewMode === 'calendar' ? { backgroundColor: colors.primary.headingsBody, borderColor: colors.primary.headingsBody } : {}}
                >
                  <svg className="h-4 w-4 mr-1.5 sm:mr-2 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
                  <span>Calendar</span>
                </button>
                <button
                  onClick={() => {
                    setViewMode('list');
                    localStorage.setItem('jobsViewMode', 'list');
                  }}
                  className={`inline-flex items-center px-3 py-2 sm:px-4 rounded-md border transition-colors duration-200 shadow-sm whitespace-nowrap text-sm ${viewMode === 'list' ? 'bg-primary-headings text-white border-primary-headings' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                    }`}
                  style={viewMode === 'list' ? { backgroundColor: colors.primary.headingsBody, borderColor: colors.primary.headingsBody } : {}}
                >
                  <svg className="h-4 w-4 mr-1.5 sm:mr-2 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" /></svg>
                  <span>List</span>
                </button>
                <button
                  onClick={() => setShowArchivedJobs(!showArchivedJobs)}
                  className={`inline-flex items-center px-3 py-2 sm:px-4 rounded-md border transition-colors duration-200 shadow-sm whitespace-nowrap text-sm ${showArchivedJobs
                    ? 'bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200'
                    : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                    }`}
                >
                  <IoMdArchive className="h-4 w-4 mr-1.5 sm:mr-2 shrink-0" />
                  <span className="hidden sm:inline">{showArchivedJobs ? `Show Active ${jobPluralLabel}` : `Show Archived ${jobPluralLabel}`}</span>
                  <span className="sm:hidden">{showArchivedJobs ? 'Active' : 'Archived'}</span>
                </button>
              </div>
            )}
          </div>

          {/* Search and Actions Bar */}
          <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 flex flex-col sm:flex-row gap-4 items-stretch sm:items-center min-w-0">
            <div className="relative flex-1 min-w-0">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <IoSearch className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="text"
                value={inputValue}
                onChange={handleSearchChange}
                className="block w-full min-w-0 pl-10 pr-3 py-2.5 border border-gray-200 rounded-lg focus:ring-2 focus:ring-primary-light focus:border-transparent text-sm"
                placeholder={
                  showArchivedJobs
                    ? `Search archived ${jobPluralLabel.toLowerCase()}...`
                    : `Search ${jobPluralLabel.toLowerCase()}...`
                }
              />
            </div>
            {!showArchivedJobs && (
              <button
                onClick={handleCreateJob}
                className="inline-flex items-center justify-center px-6 py-2.5 text-white rounded-lg bg-cta hover:bg-opacity-90 transition-all duration-200 shadow-sm font-medium whitespace-nowrap w-full sm:w-auto shrink-0"
                style={{ backgroundColor: colors.highlights.callToAction }}
              >
                <svg className="w-5 h-5 mr-2 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
                {`Create ${jobLabel}`}
              </button>
            )}
          </div>

          <div className="relative z-10 bg-white rounded-xl p-4 shadow-sm border border-gray-100 flex flex-col gap-4 mt-2 min-w-0">
            <div className="flex flex-wrap justify-center sm:justify-start items-center gap-2 sm:gap-4 w-full min-w-0">
              {!drafts &&
                <div className="relative" ref={approvalDropdownRef}>
                  <button
                    onClick={() => setShowApprovalDropdown(!showApprovalDropdown)}
                    className="inline-flex items-center px-4 py-2.5 border border-gray-200 rounded-lg hover:bg-gray-50 transition-all duration-200"
                  >
                    <span className="text-sm font-medium text-gray-700">
                      {jobPluralLabel}
                    </span>
                    {showApprovalDropdown ? <IoChevronUp className="ml-2 w-4 h-4" /> : <IoChevronDown className="ml-2 w-4 h-4" />}
                  </button>

                  {showApprovalDropdown && (
                    <div className="absolute left-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-[100]">
                      <div className="py-1">
                        {approvalStatusOptions.map(option => (
                          <div
                            key={option.value}
                            className="flex items-center px-4 py-2 hover:bg-gray-50 cursor-pointer"
                            onClick={() => {
                              setApprovalStatus(option.value);
                              setShowApprovalDropdown(false);
                            }}
                          >
                            <span className={`text-sm ${approvalStatus === option.value ? 'text-primary-headings font-medium' : 'text-gray-700'}`}>
                              {option.label}
                            </span>
                            {approvalStatus === option.value && (
                              <svg className="w-4 h-4 ml-2 text-primary-headings" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                              </svg>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              }

              {/* Category Filter */}
              <div className="relative" ref={categoryDropdownRef}>
                <button
                  onClick={() => setShowCategoryDropdown(!showCategoryDropdown)}
                  className="inline-flex items-center px-4 py-2.5 border border-gray-200 rounded-lg hover:bg-gray-50 transition-all duration-200"
                >
                  <span className="text-sm font-medium text-gray-700">
                    Categories {selectedCategories.length > 0 && `(${selectedCategories.length})`}
                  </span>
                  {showCategoryDropdown ? <IoChevronUp className="ml-2 w-4 h-4" /> : <IoChevronDown className="ml-2 w-4 h-4" />}
                </button>

                {showCategoryDropdown && (
                  <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 z-[100]">
                    <div className="p-3">
                      <input
                        type="text"
                        placeholder="Search categories..."
                        className="w-full px-3 py-2 text-sm border border-gray-200 rounded-md"
                        value={categorySearchTerm}
                        onChange={(e) => setCategorySearchTerm(e.target.value)}
                        autoFocus
                      />
                      <div className="mt-2 max-h-60 overflow-y-auto">
                        {filteredCategories
                          ?.map(category => (
                            <div
                              key={category._id}
                              className="flex items-center px-3 py-2 hover:bg-gray-50 cursor-pointer"
                              onClick={() => handleCategorySelect(category._id)}
                            >
                              <input
                                type="checkbox"
                                checked={selectedCategories.includes(category._id)}
                                readOnly
                                className="h-4 w-4 text-primary-headings rounded"
                              />
                              <span className="ml-3 text-sm">{category.categoryType}</span>
                            </div>
                          ))
                        }
                        {filteredCategories.length === 0 && (
                          <div className="text-center text-gray-500 py-2">
                            No categories found
                          </div>
                        )}
                      </div>
                      {selectedCategories.length > 0 && (
                        <div className="border-t mt-2 pt-2">
                          <button
                            onClick={() => setSelectedCategories([])}
                            className="text-sm text-red-500 hover:text-red-700"
                          >
                            Clear all
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* Employee Filter */}
              <div className="relative" ref={employeeDropdownRef}>
                <button
                  onClick={() => setShowEmployeeDropdown(!showEmployeeDropdown)}
                  className="inline-flex items-center px-4 py-2.5 border border-gray-200 rounded-lg hover:bg-gray-50 transition-all duration-200"
                >
                  <span className="text-sm font-medium text-gray-700">
                    Employees {selectedEmployees.length > 0 && `(${selectedEmployees.length})`}
                  </span>
                  {showEmployeeDropdown ? <IoChevronUp className="ml-2 w-4 h-4" /> : <IoChevronDown className="ml-2 w-4 h-4" />}
                </button>

                {showEmployeeDropdown && (
                  <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 z-[100]">
                    <div className="p-3">
                      <input
                        type="text"
                        placeholder="Search employees..."
                        className="w-full px-3 py-2 text-sm border border-gray-200 rounded-md"
                        value={employeeSearchTerm}
                        onChange={(e) => setEmployeeSearchTerm(e.target.value)}
                        autoFocus
                      />
                      <div className="mt-2 max-h-60 overflow-y-auto">
                        {filteredEmployees
                          ?.map(employee => (
                            <div
                              key={employee._id}
                              className="flex items-center px-3 py-2 hover:bg-gray-50 cursor-pointer"
                              onClick={() => handleEmployeeSelect(employee._id)}
                            >
                              <input
                                type="checkbox"
                                checked={selectedEmployees.includes(employee._id)}
                                readOnly
                                className="h-4 w-4 text-primary-headings rounded"
                              />
                              <span className="ml-3 text-sm">{`${employee.name}`}</span>
                            </div>
                          ))
                        }
                        {filteredEmployees.length === 0 && (
                          <div className="text-center text-gray-500 py-2">
                            No employees found
                          </div>
                        )}
                      </div>
                      {selectedEmployees.length > 0 && (
                        <div className="border-t mt-2 pt-2">
                          <button
                            onClick={() => setSelectedEmployees([])}
                            className="text-sm text-red-500 hover:text-red-700"
                          >
                            Clear all
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* Customer Filter */}
              <div className="relative" ref={customerDropdownRef}>
                <button
                  onClick={() => setShowCustomerDropdown(!showCustomerDropdown)}
                  className="inline-flex items-center px-4 py-2.5 border border-gray-200 rounded-lg hover:bg-gray-50 transition-all duration-200"
                >
                  <span className="text-sm font-medium text-gray-700">
                    Customers {selectedCustomers.length > 0 && `(${selectedCustomers.length})`}
                  </span>
                  {showCustomerDropdown ? <IoChevronUp className="ml-2 w-4 h-4" /> : <IoChevronDown className="ml-2 w-4 h-4" />}
                </button>

                {showCustomerDropdown && (
                  <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 z-[100]">
                    <div className="p-3">
                      <input
                        type="text"
                        placeholder="Search customers..."
                        className="w-full px-3 py-2 text-sm border border-gray-200 rounded-md"
                        value={customerSearchTerm}
                        onChange={(e) => setCustomerSearchTerm(e.target.value)}
                        autoFocus
                      />
                      <div className="mt-2 max-h-60 overflow-y-auto">
                        {filteredCustomers
                          ?.map(customer => (
                            <div
                              key={customer._id}
                              className="flex items-center px-3 py-2 hover:bg-gray-50 cursor-pointer"
                              onClick={() => handleCustomerSelect(customer._id)}
                            >
                              <input
                                type="checkbox"
                                checked={selectedCustomers.includes(customer._id)}
                                readOnly
                                className="h-4 w-4 text-primary-headings rounded"
                              />
                              <span className="ml-3 text-sm">{`${customer.name}`}</span>
                            </div>
                          ))
                        }
                        {filteredCustomers.length === 0 && (
                          <div className="text-center text-gray-500 py-2">
                            No customers found
                          </div>
                        )}
                      </div>
                      {selectedCustomers.length > 0 && (
                        <div className="border-t mt-2 pt-2">
                          <button
                            onClick={() => setSelectedCustomers([])}
                            className="text-sm text-red-500 hover:text-red-700"
                          >
                            Clear all
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* Task Filter */}
              <div className="relative" ref={taskDropdownRef}>
                <button
                  onClick={() => setShowTaskDropdown(!showTaskDropdown)}
                  className="inline-flex items-center px-4 py-2.5 border border-gray-200 rounded-lg hover:bg-gray-50 transition-all duration-200"
                >
                  <span className="text-sm font-medium text-gray-700">
                    Tasks {selectedTasks.length > 0 && `(${selectedTasks.length})`}
                  </span>
                  {showTaskDropdown ? <IoChevronUp className="ml-2 w-4 h-4" /> : <IoChevronDown className="ml-2 w-4 h-4" />}
                </button>

                {showTaskDropdown && (
                  <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 z-[100]">
                    <div className="p-3">
                      <input
                        type="text"
                        placeholder="Search tasks..."
                        className="w-full px-3 py-2 text-sm border border-gray-200 rounded-md"
                        value={taskSearchTerm}
                        onChange={(e) => setTaskSearchTerm(e.target.value)}
                        autoFocus
                      />
                      <div className="mt-2 max-h-60 overflow-y-auto">
                        {filteredTasks
                          ?.map(task => (
                            <div
                              key={task._id}
                              className="flex items-center px-3 py-2 hover:bg-gray-50 cursor-pointer"
                              onClick={() => handleTaskSelect(task._id)}
                            >
                              <input
                                type="checkbox"
                                checked={selectedTasks.includes(task._id)}
                                readOnly
                                className="h-4 w-4 text-primary-headings rounded"
                              />
                              <span className="ml-3 text-sm">{task.title}</span>
                            </div>
                          ))
                        }
                        {filteredTasks.length === 0 && (
                          <div className="text-center text-gray-500 py-2">
                            No tasks found
                          </div>
                        )}
                      </div>
                      {selectedTasks.length > 0 && (
                        <div className="border-t mt-2 pt-2">
                          <button
                            onClick={() => setSelectedTasks([])}
                            className="text-sm text-red-500 hover:text-red-700"
                          >
                            Clear all
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {viewMode === 'list' && dateRangeButton}
            </div>
          </div>

          {/* Add Status Tabs/Dropdown after the search and actions bar */}
          {!showArchivedJobs && (
            <div className="mt-6">
              {/* Desktop Tabs */}
              {!drafts &&
                <div className="hidden md:flex bg-white rounded-xl p-2 shadow-sm border border-gray-100">
                  {statusOptions.map((status) => (
                    <button
                      key={status.value}
                      onClick={() => handleStatusChange(status.value)}
                      className={`flex-1 px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 ${selectedStatus === status.value
                        ? 'bg-primary-headings text-white'
                        : 'text-gray-600 hover:bg-gray-100'
                        }`}
                      style={{
                        backgroundColor: selectedStatus === status.value ? colors.primary.headingsBody : '',
                      }}
                    >
                      {status.label}
                    </button>
                  ))}
                </div>
              }

              {/* Mobile Dropdown */}
              <div className="md:hidden">
                <Menu as="div" className="relative">
                  <Menu.Button className="w-full bg-white rounded-xl px-4 py-2 text-left shadow-sm border border-gray-100 flex items-center justify-between">
                    <span className="text-sm font-medium text-gray-700">
                      {statusOptions.find(s => s.value === selectedStatus)?.label}
                    </span>
                    <ChevronDownIcon className="w-5 h-5 text-gray-400" />
                  </Menu.Button>
                  <Transition
                    enter="transition duration-100 ease-out"
                    enterFrom="transform scale-95 opacity-0"
                    enterTo="transform scale-100 opacity-100"
                    leave="transition duration-75 ease-out"
                    leaveFrom="transform scale-100 opacity-100"
                    leaveTo="transform scale-95 opacity-0"
                  >
                    <Menu.Items className="absolute z-10 mt-2 w-full bg-white rounded-xl shadow-lg border border-gray-100 focus:outline-none">
                      <div className="py-1">
                        {statusOptions.map((status) => (
                          <Menu.Item key={status.value}>
                            {({ active }) => (
                              <button
                                onClick={() => handleStatusChange(status.value)}
                                className={`${active ? 'bg-gray-100' : ''
                                  } ${selectedStatus === status.value ? 'text-primary-headings' : 'text-gray-700'
                                  } w-full text-left px-4 py-2 text-sm`}
                              >
                                {status.label}
                              </button>
                            )}
                          </Menu.Item>
                        ))}
                      </div>
                    </Menu.Items>
                  </Transition>
                </Menu>
              </div>
            </div>
          )}
        </div>

        {/* Calendar or Table */}
        {viewMode === 'calendar' ? (
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 mb-8">
            {isLoading ? (
              <div className="flex items-center justify-center py-20">
                <div className="w-8 h-8 border-4 border-gray-300 rounded-full animate-spin" style={{ borderTopColor: colors.primary.headingsBody }} />
                <span className="ml-3 text-gray-600">Loading...</span>
              </div>
            ) : (
              <JobCalendar
                jobs={jobList}
                showArchived={showArchivedJobs}
                date={calendarDate}
                view={calendarView}
                onNavigate={(date) => {
                  setCalendarDate(date);
                  setCalendarRange(getCalendarRange(calendarView, date));
                }}
                onView={(view) => {
                  setCalendarView(view);
                  setCalendarRange(getCalendarRange(view, calendarDate));
                }}
              />
            )}
          </div>
        ) : (
          <div className="bg-white rounded-xl shadow-sm overflow-hidden max-h-[calc(100vh-480px)] flex flex-col mb-8">
            <div className="overflow-x-auto flex-1">
              <table className="w-full">
                <thead className="bg-white z-10 after:absolute after:inset-x-0 after:bottom-0 after:h-[1px] after:bg-gray-200">
                  <tr>
                    <th className="w-[60px] min-w-[60px] px-4 py-3 text-left text-xs font-semibold text-primary-headings uppercase tracking-wider sticky top-0 bg-gray-100">No</th>
                    <th className="w-full min-w-[200px] px-4 py-3 text-left text-xs font-semibold text-primary-headings uppercase tracking-wider sticky top-0 bg-gray-100">{`${jobLabel} Title`}</th>
                    <th className="w-[120px] min-w-[120px] px-4 py-3 text-left text-xs font-semibold text-primary-headings uppercase tracking-wider sticky top-0 bg-gray-100">Status</th>
                    <th className="w-[120px] min-w-[120px] px-4 py-3 text-left text-xs font-semibold text-primary-headings uppercase tracking-wider sticky top-0 bg-gray-100">Date</th>
                    <th className="w-[100px] min-w-[100px] px-4 py-3 text-left text-xs font-semibold text-primary-headings uppercase tracking-wider sticky top-0 bg-gray-100">Start Time</th>
                    <th className="w-[100px] min-w-[100px] px-4 py-3 text-left text-xs font-semibold text-primary-headings uppercase tracking-wider sticky top-0 bg-gray-100">End Time</th>
                    <th className="w-[100px] min-w-[100px] px-4 py-3 text-left text-xs font-semibold text-primary-headings uppercase tracking-wider sticky top-0 bg-gray-100">{chargeOutRateTitle}</th>
                    <th className="w-[120px] min-w-[120px] px-4 py-3 text-center text-xs font-semibold text-primary-headings uppercase tracking-wider sticky top-0 bg-gray-100">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {loading || isLoading ? (
                    <tr>
                      <td colSpan="8" className="px-4 py-8">
                        <div className="flex items-center justify-center">
                          <div className="w-8 h-8 border-4 border-gray-300 rounded-full animate-spin" style={{ borderTopColor: colors.primary.headingsBody }}></div>
                          <span className="ml-3 text-gray-600">{`Loading ${jobPluralLabel.toLowerCase()}...`}</span>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    <>
                      {jobList?.map((job, index) => {
                        const isUnApproved = !job.approved;

                        const titleToRender = job.title;
                        const statusToRender = job.status ? job.status.charAt(0).toUpperCase() + job.status.slice(1) : '';
                        const dateToRender = job.scheduledDate ? formatDate(job.scheduledDate) : '';
                        const totalCostToRender = job?.cost?.total ? `$${job.cost.total}` : '';

                        let startTime = job.scheduledStartTime;
                        if (startTime && startTime.includes('T')) {
                          const startDate = new Date(startTime);
                          startTime = startDate.toLocaleTimeString('en-US', {
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: false
                          });
                        }

                        // Format end time
                        let endTime = job.scheduledEndTime;
                        if (endTime && endTime.includes('T')) {
                          const endDate = new Date(endTime);
                          endTime = endDate.toLocaleTimeString('en-US', {
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: false
                          });
                        }

                        // Calculate expiry for recurring jobs
                        let isExpiringSoon = false;
                        let daysUntilExpiry = null;
                        if (job.reoccurrence && job.reoccurrence.repeatTill && job.isLastRecurringJob) {
                          const repeatTillDate = new Date(job.reoccurrence.repeatTill);
                          if (!isNaN(repeatTillDate.getTime())) {
                            daysUntilExpiry = Math.ceil((repeatTillDate - new Date()) / (1000 * 60 * 60 * 24));
                            if (daysUntilExpiry <= 7 && daysUntilExpiry >= 0) {
                              isExpiringSoon = true;
                            }
                          }
                        }

                        return (
                          <tr
                            key={index}
                            className={`hover:bg-gray-50 cursor-pointer ${isUnApproved ? 'bg-red-50' : ''}`}
                            onClick={() => drafts ? navigate(`/edit-job/${job._id}?draft=true`) : navigate(`/view-job/${job._id}`)}
                          >
                            <td className="w-[60px] min-w-[60px] px-4 py-3 text-sm font-medium text-primary-headings whitespace-nowrap">
                              {(pageVal - 1) * jobsPerPage + index + 1}.
                            </td>
                            <td className="w-full min-w-[200px] px-4 py-3">
                              <div className="flex items-center">
                                <span className="text-sm font-medium text-primary-headings truncate flex items-center gap-2">
                                  <span>{titleToRender.length > 50 ? titleToRender.slice(0, 50) + '...' : titleToRender}</span>
                                  {isUnApproved && <span className="text-xs text-red-500 bg-white px-2 py-0.5 rounded-full italic border border-red-100">Not Approved</span>}
                                  {isExpiringSoon && (
                                    <span
                                      className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold bg-red-50 text-red-600 border border-red-200 uppercase tracking-wider whitespace-nowrap"
                                      title={`Recurring series expires in ${daysUntilExpiry} day${daysUntilExpiry !== 1 ? 's' : ''}`}
                                    >
                                      ⚠️ Expiring Soon
                                    </span>
                                  )}
                                </span>
                              </div>
                            </td>
                            <td className="w-[120px] min-w-[120px] px-4 py-3">
                              <span
                                className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap"
                                style={{
                                  backgroundColor: showArchivedJobs
                                    ? '#fef3c7' // Light yellow for archived
                                    : job.status === "COMPLETED"
                                      ? '#dcfce7'
                                      : job.status === "PENDING"
                                        ? '#fef9c3'
                                        : job.status === "STARTED"
                                          ? '#dbeafe'
                                          : '#fee2e2',
                                  color: showArchivedJobs
                                    ? '#92400e' // Dark yellow for archived
                                    : job.status === "COMPLETED"
                                      ? '#166534'
                                      : job.status === "PENDING"
                                        ? '#854d0e'
                                        : job.status === "STARTED"
                                          ? '#1e40af'
                                          : '#991b1b'
                                }}
                              >
                                {showArchivedJobs ? 'ARCHIVED' : (statusToRender === 'FAILED' ? 'Incomplete' : statusToRender)}
                              </span>
                            </td>
                            <td className="w-[120px] min-w-[120px] px-4 py-3 text-sm text-gray-900 whitespace-nowrap">
                              {dateToRender}
                            </td>
                            <td className="w-[100px] min-w-[100px] px-4 py-3 text-sm text-gray-900 whitespace-nowrap">
                              {startTime}
                            </td>
                            <td className="w-[100px] min-w-[100px] px-4 py-3 text-sm text-gray-900 whitespace-nowrap">
                              {endTime}
                            </td>
                            <td className="w-[100px] min-w-[100px] px-4 py-3 text-sm text-gray-900 whitespace-nowrap">
                              {totalCostToRender}
                            </td>
                            <td className="w-[120px] min-w-[120px] px-4 py-3">
                              <div className="flex justify-center space-x-2 overflow-x-auto">
                                {!drafts &&
                                  <Link
                                    to={`/view-job/${job._id}`}
                                    className="p-1.5 hover:bg-blue-50 rounded-lg transition-colors duration-200 shrink-0"
                                    title="View"
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <IoEyeOutline size={18} className="text-blue-500" />
                                  </Link>
                                }
                                {!drafts && (
                                  <Link
                                    to={`/edit-job/${job._id}`}
                                    className="p-1.5 rounded-lg transition-colors duration-200 shrink-0 cursor-pointer hover:bg-indigo-50"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                    }}
                                    title="Edit"
                                  >
                                    <HiOutlinePencilAlt size={18} className="text-indigo-500" />
                                  </Link>
                                )}
                                {!drafts && !showArchivedJobs &&
                                  <Link
                                    to={`/create-job/${job._id}`}
                                    className="p-1.5 hover:bg-green-50 rounded-lg transition-colors duration-200 shrink-0"
                                    title="Clone"
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <IoDuplicateOutline size={18} className="text-green-600" />
                                  </Link>
                                }
                                {!drafts && (
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleArchiveJob(job._id, !showArchivedJobs);
                                    }}
                                    className="p-1.5 hover:bg-yellow-50 rounded-lg transition-colors duration-200 shrink-0"
                                    title={showArchivedJobs ? "Unarchive" : "Archive"}
                                    disabled={archivingJob === job._id}
                                  >
                                    {archivingJob === job._id ? (
                                      <div className="w-4 h-4 border-2 border-yellow-500 border-t-transparent rounded-full animate-spin"></div>
                                    ) : (
                                      <IoMdArchive size={18} className="text-yellow-600" />
                                    )}
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        )
                      })}

                      {jobList.length === 0 && !loading && !isLoading && (
                        <tr>
                          <td colSpan="8" className="px-4 py-8 text-center">
                            <div className="flex flex-col items-center justify-center">
                              <IoSearch size={48} className="text-gray-400 mb-4" />
                              <h3 className="text-lg font-medium text-gray-900 mb-2">{`No ${jobPluralLabel.toLowerCase()} found`}</h3>
                              <p className="text-gray-500">Try adjusting your search or filters to find what you're looking for.</p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>

            {!loading && !isLoading && jobList.length > 0 && (
              <div className="px-6 py-4 bg-gray-50 border-t border-gray-200">
                <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                  <p className="text-sm text-gray-700">
                    Showing <span className="font-medium">{jobsPerPage * (pageVal - 1) + 1}</span> to{' '}
                    <span className="font-medium">{jobsPerPage * (pageVal - 1) + jobList.length}</span> of{' '}
                    <span className="font-medium">{totalJobs}</span> results
                  </p>
                  <nav className="flex items-center gap-2">
                    <button
                      onClick={handlePreviousPageClick}
                      disabled={pageVal === 1}
                      style={{
                        backgroundColor: pageVal === 1 ? '#f3f4f6' : colors.primary.headingsBody,
                        color: pageVal === 1 ? '#9ca3af' : 'white',
                        cursor: pageVal === 1 ? 'not-allowed' : 'pointer'
                      }}
                      className="px-3 py-1 rounded-md text-sm font-medium hover:bg-opacity-90"
                    >
                      Previous
                    </button>
                    {totalPages > 0 && (
                      <>
                        <button
                          style={{
                            backgroundColor: pageVal === pgItem1 ? colors.primary.headingsBody : '#f3f4f6',
                            color: pageVal === pgItem1 ? 'white' : '#374151'
                          }}
                          className="px-3 py-1 rounded-md text-sm font-medium hover:bg-gray-200"
                          onClick={() => setPageVal(pgItem1)}
                        >
                          {pgItem1}
                        </button>
                        {totalPages > 1 && (
                          <button
                            style={{
                              backgroundColor: pageVal === pgItem2 ? colors.primary.headingsBody : '#f3f4f6',
                              color: pageVal === pgItem2 ? 'white' : '#374151'
                            }}
                            className="px-3 py-1 rounded-md text-sm font-medium hover:bg-gray-200"
                            onClick={() => setPageVal(pgItem2)}
                          >
                            {pgItem2}
                          </button>
                        )}
                        {totalPages > 2 && (
                          <button
                            style={{
                              backgroundColor: pageVal === pgItem3 ? colors.primary.headingsBody : '#f3f4f6',
                              color: pageVal === pgItem3 ? 'white' : '#374151'
                            }}
                            className="px-3 py-1 rounded-md text-sm font-medium hover:bg-gray-200"
                            onClick={() => setPageVal(pgItem3)}
                          >
                            {pgItem3}
                          </button>
                        )}
                      </>
                    )}
                    <button
                      onClick={handleNextPageClick}
                      disabled={pageVal >= totalPages}
                      style={{
                        backgroundColor: pageVal >= totalPages ? '#f3f4f6' : colors.primary.headingsBody,
                        color: pageVal >= totalPages ? '#9ca3af' : 'white',
                        cursor: pageVal >= totalPages ? 'not-allowed' : 'pointer'
                      }}
                      className="px-3 py-1 rounded-md text-sm font-medium hover:bg-opacity-90"
                    >
                      Next
                    </button>
                  </nav>
                </div>
              </div>
            )}
          </div>
        )}

        {loading === 2 && (
          <div className="flex flex-col items-center mt-5 pt-5">
            <MdOutlineWifiTetheringErrorRounded size={120} className="text-gray-400" />
            <h2 className="text-xl font-semibold text-gray-800 mt-4">Error fetching data</h2>
            <h3 className="text-gray-500 mt-2">Check your network and try again</h3>
          </div>
        )}

        {showDeleteModal && (
          <DeleteModal
            deleteItem={jobLabel}
            onDelete={handleConfirmDelete}
            onClose={() => {
              setShowDeleteModal(false);
              setJobToDelete(null);
            }}
          />
        )}
      </div>
    </>
  );
};

export default ListJob;
